import { Injectable, inject } from '@angular/core';
import { JSONSchema, StorageMap } from '@ngx-pwa/local-storage';
import { HeaderService } from 'onego-header';
import { Observable } from 'rxjs';
import { IIdentityClaims } from 'shared';

@Injectable({ providedIn: 'root' })
export class UserScopedStorageService {
    private readonly storage = inject(StorageMap);
    private readonly headerService = inject(HeaderService);

    public get<T = unknown>(key: string, schema?: JSONSchema): Observable<T> {
        const scopedKey = this.scopedKey(key);
        return (schema ? this.storage.get(scopedKey, schema) : this.storage.get(scopedKey)) as Observable<T>;
    }

    public set(key: string, value: unknown): Observable<undefined> {
        return this.storage.set(this.scopedKey(key), value);
    }

    public delete(key: string): Observable<undefined> {
        return this.storage.delete(this.scopedKey(key));
    }

    public getLocal<T>(key: string): T | null {
        const raw = window.localStorage.getItem(this.scopedKey(key));
        if (!raw) return null;
        try {
            return JSON.parse(raw) as T;
        } catch {
            return null;
        }
    }

    public setLocal(key: string, value: unknown): void {
        window.localStorage.setItem(this.scopedKey(key), JSON.stringify(value));
    }

    private scopedKey(key: string): string {
        const claims = this.headerService.getClaims() as IIdentityClaims | null;
        const userId = claims?.MtpUserId ?? claims?.sub ?? 'anonymous';
        return `${userId}:${key}`;
    }
}
